var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.numInputs > 1
    ? _c(
        "div",
        { staticClass: "otp-input" },
        _vm._l(_vm.numInputs, function (i) {
          return _c("input", {
            attrs: {
              id: _vm.getInputId(i),
              type: "number",
              inputmode: "tel",
              min: "0",
              max: "9",
              maxlength: "1",
              autocomplete: "one-time-code",
            },
            on: {
              input: _vm.handleOnChange,
              click: _vm.handleOnClick,
              keydown: _vm.handleOnKeyDown,
            },
          })
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }